import axios from 'axios';

export function HTTP_GO(token) {
  return axios.create({
    baseURL:window.process.env.API_GO_HOST,
    headers: {
      Authorization: token,
    },
  });
}



// WEBPACK FOOTER //
// ./src/core/http/http-common-go.js